module.exports = __webpack_public_path__ + "img/glogin-bg.858e714c.png";